import { createTypes } from "../../../utils/redux/create-types";

export default createTypes(
    `
    FETCH_BANK_OFFER_COUPONS_SUCCESS
    FETCH_BANK_OFFER_COUPONS_FAILURE
    SET_SHOW_SELECTED_BANK_OFFER
    UPDATE_SSR_STATUS
`,
    {
        prefix: "savedFilters/"
    }
);
